import { Link } from 'react-router-dom';
import { articles } from '@/mocks/gossip';
import ArticleCard from '@/components/feature/ArticleCard';

const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

export default function LatestArticles() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 border-b-2 border-foreground-950 pb-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="text-xs font-medium tracking-[0.25em] text-primary-600">LATEST</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新爆料</h2>
        </div>
        <Link
          to="/gossip"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
        >
          进入吃瓜广场
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}